import React from 'react'
import { useI18n } from '../../i18n'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

export type ArtifactTabKey =
  | 'all'
  | 'logs'
  | 'screenshots'
  | 'configurations'
  | 'diagrams'
  | 'metrics'
  | 'reports'
  | 'exports'
  | 'approvals'
  | 'registers'
  | 'other'

/** Operational evidence only — policies/procedures live in Policies & Governance. */
const TABS: ArtifactTabKey[] = [
  'all',
  'logs',
  'screenshots',
  'configurations',
  'diagrams',
  'metrics',
  'reports',
  'exports',
  'approvals',
  'registers',
  'other',
]

type Props = {
  active: ArtifactTabKey
  onChange: (tab: ArtifactTabKey) => void
}

export function EvidenceArtifactCategoryTabs({ active, onChange }: Props) {
  const { t } = useI18n()

  const label = (tab: ArtifactTabKey) => {
    const map: Record<ArtifactTabKey, string> = {
      all: t('governance.evidenceArtifacts.tabAll', 'All Evidence'),
      logs: t('governance.evidenceArtifacts.logs', 'Logs'),
      screenshots: t('governance.evidenceArtifacts.screenshots', 'Screenshots'),
      configurations: t('governance.evidenceArtifacts.configurations', 'Configurations'),
      diagrams: t('governance.evidenceArtifacts.diagrams', 'Diagrams'),
      metrics: t('governance.evidenceArtifacts.metrics', 'Metrics'),
      reports: t('governance.evidenceArtifacts.reports', 'Reports'),
      exports: t('governance.evidenceArtifacts.exports', 'Exports'),
      approvals: t('governance.evidenceArtifacts.approvals', 'Approvals'),
      registers: t('governance.evidenceArtifacts.registers', 'Registers'),
      other: t('governance.evidenceArtifacts.other', 'Other'),
    }
    return map[tab]
  }

  return (
    <div className={listStyles.artifactCategoryTabsBar}>
      <p className={listStyles.artifactCategoryTabsLabel}>
        {t('governance.evidenceArtifacts.artifactCategory', 'Artifact category')}
      </p>
      <div
        className={listStyles.segmentedTabs}
        role="tablist"
        aria-label={t('governance.evidenceArtifacts.artifactCategory', 'Artifact category')}
      >
        {TABS.map((tab) => (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={active === tab}
            className={`${listStyles.segmentedTab} ${active === tab ? listStyles.segmentedTabActive : ''}`}
            onClick={() => onChange(tab)}
          >
            {label(tab)}
          </button>
        ))}
      </div>
    </div>
  )
}
